import { render } from "./Mainpage.vue?vue&type=template&id=7ac84278&scoped=true"
import script from "./Mainpage.vue?vue&type=script&lang=js"
export * from "./Mainpage.vue?vue&type=script&lang=js"

import "./Mainpage.vue?vue&type=style&index=0&id=7ac84278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac84278"]])

export default __exports__